import { render, staticRenderFns } from "./televet.vue?vue&type=template&id=3d409ced&scoped=true&"
import script from "./televet.vue?vue&type=script&lang=js&"
export * from "./televet.vue?vue&type=script&lang=js&"
import style0 from "./televet.vue?vue&type=style&index=0&id=3d409ced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d409ced",
  null
  
)

export default component.exports